/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

export const OrderNumberCell = ({
  orderValue,
  onView,
  ariaLabel = "View",
}) => {
  if (!orderValue) {
    return null;
  }

  return (
    <Tooltip title="View" arrow>
      <IconButton
        data-testid="order-number-cell-view-button"
        aria-label={ariaLabel}
        onClick={() => onView(orderValue)}
        size="small"
        sx={{
          padding: "4px",
          flexShrink: 0,
        }}
      >
        <VisibilityIcon
          sx={{
            color: "#707070",
            cursor: "pointer",
          }}
        />
      </IconButton>
    </Tooltip>
  );
};
